import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextButton from 'components/TextButton';
import ArrowDown from 'resources/arrow-down.png';
import ArrowUp from 'resources/arrow-up.png';
import CollapsibleContext from './CollapsibleContext';
import './Toggle.css';

class Toggle extends Component {
  render() {
    const { className } = this.props;
    return (
      <CollapsibleContext.Consumer>
        {({ open, toggleCollapse }) => (
          <TextButton
            className={`collapsible-toggle ${className} ${
              open ? 'hide-content' : 'show-content'
            }`}
            aria-label={open ? 'Collapse Content' : 'Expand Content'}
            aria-expanded={open}
            onClick={() => toggleCollapse()}
          >
            <img
              className="toggle-icon"
              src={open ? ArrowUp : ArrowDown}
              alt=""
            />
          </TextButton>
        )}
      </CollapsibleContext.Consumer>
    );
  }
}

Toggle.propTypes = {
  expandLabel: PropTypes.string,
  collapseLabel: PropTypes.string
};

export default Toggle;
